import { render, staticRenderFns } from "./WarningList.vue?vue&type=template&id=06b207dc&scoped=true&"
import script from "./WarningList.vue?vue&type=script&lang=ts&"
export * from "./WarningList.vue?vue&type=script&lang=ts&"
import style0 from "./WarningList.vue?vue&type=style&index=0&id=06b207dc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b207dc",
  null
  
)

export default component.exports